/* __next_internal_client_entry_do_not_use__ BrandPageProductsStateContext,useBrandPageProductsStateContext,BrandPageProductsClientStateContextProvider auto */ import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from "react";
import { useBrandProductsQueryWithQueryParams } from "./__internal__/useBrandProductsQuery";
var DEFAULT_BRAND_PRODUCTS_STATE_CONTEXT = {
    productsQueryPromise: Promise.resolve(undefined),
    productsFiltersPromise: Promise.resolve(undefined),
    productsCollectionsPromise: Promise.resolve(undefined),
    legacyProductsQueryData: undefined,
    brandToken: "",
    queryParams: undefined
};
export var BrandPageProductsStateContext = /*#__PURE__*/ React.createContext(DEFAULT_BRAND_PRODUCTS_STATE_CONTEXT);
export var useBrandPageProductsStateContext = function() {
    var value = useContext(BrandPageProductsStateContext);
    if (value === DEFAULT_BRAND_PRODUCTS_STATE_CONTEXT) {
        throw new Error("useBrandPageProductsStateContext must be used within a BrandPageProductsStateContext.Provider");
    }
    return value;
};
export var BrandPageProductsClientStateContextProvider = function(param) {
    var brandToken = param.brandToken, children = param.children;
    var _useBrandProductsQueryWithQueryParams = useBrandProductsQueryWithQueryParams(brandToken), productsQueryData = _useBrandProductsQueryWithQueryParams.productsQueryData, queryParams = _useBrandProductsQueryWithQueryParams.queryParams;
    return /*#__PURE__*/ _jsx(BrandPageProductsStateContext.Provider, {
        value: {
            legacyProductsQueryData: productsQueryData,
            brandToken: brandToken,
            queryParams: queryParams
        },
        children: children
    });
};
